(()=>{
 const init=root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const tabs=[...root.querySelectorAll('[role=tab]')];
  const select=tab=>{
   tabs.forEach(item=>{const active=item===tab,panel=root.querySelector('#'+CSS.escape(item.getAttribute('aria-controls')));item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;panel.hidden=!active;panel.inert=!active;if(!active)panel.querySelectorAll('details').forEach(detail=>detail.open=false);});
  };
  tabs.forEach((tab,index)=>{
   tab.addEventListener('click',()=>select(tab));
   tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(tabs[next]);tabs[next].focus({preventScroll:true});});
  });
  root.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[role=tabpanel]');if(panel){select(tabs.find(tab=>tab.getAttribute('aria-controls')===panel.id));if(event.target.matches('details'))event.target.open=true;}});
 };
 document.querySelectorAll('[data-home-faq]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-home-faq]').forEach(init));
})();
